// @ts-nocheck
import { CompositeLayer } from '@deck.gl/core';
import IconLayer from './IconLayer';
import Supercluster from 'common/utils/Cluster/Cluster';
import { UpdateStateInfo } from '@deck.gl/core/lib/layer';

import { EMPTY_OBJECT } from 'shared/constants';


class IconClusterLayer extends CompositeLayer<{}> {
  constructor(props) {
    const { onClick, onPointermove, onDragStart, name } = props;
    super({
      ...props,
      onClick: ({ object }: any) => {
        if (object && object.data) {
          onClick({
            data: object.data,
            markerType: 'marker'
          });
        }
      },
      onHover: ({ object = {} }: any, event: any) => {
        if(onPointermove) {
          onPointermove({
            type: 'pointermove',
            data: object.data,
            pageX: event.offsetCenter.x,
            pageY: event.offsetCenter.y
          });
        }
      },
      onDragStart: ({ object = {} }: any, event: any) => {
        if(onDragStart) {
          onDragStart({
            type: 'dragStart',
            data: object.data,
            pageX: event.offsetCenter.x,
            pageY: event.offsetCenter.y
          });
        }
      },
      id: name
    });

    this.id = name;
  }

  shouldUpdateState({changeFlags}: UpdateStateInfo<{}>) {
    return changeFlags.somethingChanged;
  }

  updateState({props, oldProps, changeFlags}: UpdateStateInfo<{}>) {
    const rebuildIndex = changeFlags.dataChanged
      || !!changeFlags.propsChanged
      || props.sizeScale !== oldProps.sizeScale
      || props.selectedStation !== oldProps.selectedStation;

    if (rebuildIndex) {
      const index = new Supercluster({
        minZoom: props?.clusterZoom?.min ?? 0,
        maxZoom: props?.clusterZoom?.max ?? 8,
        radius: 75,
        minPoints: 5
      });

      index.load(
        props.data.map(item => {
          
          const { longitude, latitude, altitude } = props.getCoordinates({ data: item });
          return {
            geometry: {
              coordinates: [ longitude, latitude, altitude || 0 ]
            },
            data: item,
            layerName: props.name
          };
        })
      );

      this.setState({index});
    }

    const z = Math.round(this.context.viewport.zoom);
    if (rebuildIndex || z !== this.state.z) {
      const data = this.state.index.getClusters([-180, -85, 180, 85], z);
      this.setState({
        data,
        z
      });
    }
  }

  getPickingInfo({info, mode}) {
    const pickedObject = info.object && info.object.properties;
    if (pickedObject) {
      if (pickedObject.cluster && mode !== 'hover') {
        info.objects = this.state.index
          .getLeaves(pickedObject.cluster_id, 25)
          .map(f => f.properties);
      }
      info.object = pickedObject;
    }
    return info;
  }

  renderLayers() {
    const { data } = this.state;
    const {
      id = 'cluster-icon',
      sizeScale,
      getIcon,
      pickable,
      loadOptions,
      getCoordinates
    } = this.props;

    return [
      new IconLayer(
        this.getSubLayerProps({
          id,
          pickable,
          sizeScale,
          data,
          getPosition: ({ data = EMPTY_OBJECT, geometry }: any) => {
            const { latitude, longitude, altitude } = getCoordinates({
              data: {
                ...data,
                coordinates: {
                  latitude: geometry?.coordinates[1],
                  longitude: geometry?.coordinates[0],
                  altitude: geometry?.coordinates[2]
                }
              }
            });

            return [longitude, latitude, altitude];
          },
          getIcon: ({ data, properties = {} }) => (
            getIcon({
              data,
              ...properties.cluster && {
                clusterWeight: properties.point_count
              }
            })
          ),
          getSize: ({ data, properties = {} }) => {
            const { height } = getIcon({
              data,
                ...properties.cluster && {
                clusterWeight: properties.point_count
              }
            });

            return height;
          },
          loadOptions,
          onIconError: (error) => {
            console.error('IconLayer error', error);
          }
        })
      )
    ];
  }
}

export default IconClusterLayer;
